var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWifiMedium = function SvgIconWifiMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10.751a8.26 8.26 0 0 0-5.77 2.35 1 1 0 0 1-1.397-1.432 10.26 10.26 0 0 1 14.334 0A1 1 0 1 1 17.77 13.1 8.26 8.26 0 0 0 12 10.751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.249c-.969 0-1.9.374-2.599 1.045a1 1 0 1 1-1.384-1.444 5.753 5.753 0 0 1 7.966 0 1 1 0 1 1-1.385 1.444A3.75 3.75 0 0 0 12 15.249M13.5 18.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }))));
};
export default SvgIconWifiMedium;